import { motion, useInView } from "framer-motion";
import { useRef, useState, useEffect } from "react";

const stats = [
  { target: 25, suffix: "+", label: "Anos de experiencia" },
  { target: 500000, suffix: "+", label: "Pasajeros transportados" },
  { target: 200, suffix: "+", label: "Viajes al ano" },
  { target: 365, suffix: "", label: "Dias operativos" },
];

function Counter({ target, suffix }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isInView) return;
    let start = 0;
    const duration = 2000;
    const increment = target / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [isInView, target]);

  return (
    <span ref={ref} className="font-heading text-5xl md:text-6xl text-white">
      {count.toLocaleString()}{suffix}
    </span>
  );
}

export default function StatsBand() {
  return (
    <section
      className="relative py-16 md:py-20 bg-[#D0162A] overflow-hidden"
      data-testid="stats-band-section"
    >
      {/* Diagonal accent */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#1B3A8C] to-[#3DD9E8]" />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          {stats.map((stat, i) => (
            <div key={i} className="text-center md:text-left" data-testid={`stat-${i}`}>
              <Counter target={stat.target} suffix={stat.suffix} />
              <p className="text-white/80 text-xs uppercase tracking-[0.2em] font-body font-bold mt-2">
                {stat.label}
              </p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
